/** biome-ignore-all lint/style/useNamingConvention: camel case */
/**
 * sort the mentions array if the input is backwards,
 * which happens when we use the initial/unchanged value that is
 * not altered by the mentions' onchange handler. sortDir is in
 * ascending order by default
 *
 * @param sortDir
 * @param mentions
 */
export function sortMentions(sortDir, mentions) {
  if (!mentions) return [];
  return mentions.sort((a, b) =>
    sortDir === 'desc' ? b.start_end[0] - a.start_end[0] : a.start_end[0] - b.start_end[0]
  );
}

/**
 * transform into markup for the mention editor
 * [{user_id: '01..', 'start_end': [0, 6]}]
 *
 *
 * @param comment
 * @param mentions
 */
export function fromOurMentions(comment, mentions) {
  if (!comment || !mentions || !mentions.length) return comment;

  // biome-ignore-start lint/style/noParameterAssign: dont assign param
  mentions = mentions.sort((a, b) => b.start_end[0] - a.start_end[1]);

  for (const mention of mentions) {
    const start = comment.substr(0, mention.start_end[0]);
    const display = comment.substring(mention.start_end[0], mention.start_end[1]);
    const end = comment.substring(mention.start_end[1]);
    comment = `${start}@[${display}](${mention.user_id})${end}`;
    // biome-ignore-end lint/style/noParameterAssign: dont assign param
  }

  return comment;
}

/**
 * convert an array of objects like:
 * [{id: "01..", display: "Bob 100", type: null, index: 0, plainTextIndex: 0}]
 *
 * to:
 * [{user_id: '01..', 'start_end': [0, 6]}]
 *
 * @param mentions
 */
export function toOurMentionFormat(mentions) {
  const ret = [];
  for (const mention of mentions) {
    ret.push({
      user_id: mention.id,
      start_end: [mention.plainTextIndex, mention.plainTextIndex + mention.display.length],
    });
  }
  return ret;
}
